/* Won't Miss Garage wheels v0.1.0
   Spec lockout, spec storage, client-side spec matching, "view all", the spec modal, and wheel selection.
   Storage: localStorage key wmg_wheel_spec. It persists until an order is filed or the visitor changes it. */
(function () {
  'use strict';
  var WMG = window.WMG = window.WMG || {};
  var KEY = 'wmg_wheel_spec';
  var cfg = WMG.config || {};
  var wheelsCfg = cfg.wheels || {};

  var store = {
    get: function () { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; } },
    set: function (spec) { try { localStorage.setItem(KEY, JSON.stringify(spec)); } catch (e) {} },
    clear: function () { try { localStorage.removeItem(KEY); } catch (e) {} }
  };
  WMG.wheelSpec = store;

  var root = document.documentElement;
  var gate = document.querySelector('[data-wmg-wheel-gate]');
  var grid = document.querySelector('[data-wmg-wheel-grid]');
  var modal = document.querySelector('[data-wmg-spec-modal]');
  var statusBar = document.querySelector('[data-wmg-spec-status]');
  var chips = document.querySelector('[data-wmg-spec-chips]');
  var viewAllNote = document.querySelector('[data-wmg-view-all-note]');
  var noMatch = document.querySelector('[data-wmg-no-match]');
  var countEl = document.querySelector('[data-wmg-match-count]');
  var requireSpec = wheelsCfg.requireSpec !== false && !(grid && grid.getAttribute('data-require-spec') === 'false');
  var viewAll = false;
  var pendingHandle = null;

  /* ---------- helpers ---------- */
  function norm(s) { return String(s == null ? '' : s).toLowerCase().replace(/\s+/g, '').replace(/×/g, 'x'); }
  function list(attr) { return String(attr || '').split('|').map(norm).filter(Boolean); }
  function num(s) { var n = parseFloat(String(s).replace(/[^0-9.\-]/g, '')); return isNaN(n) ? null : n; }

  function readForm(form) {
    var get = function (name) { var el = form.querySelector('[name="' + name + '"]'); return el ? String(el.value).trim() : ''; };
    var vehicle = get('vehicle');
    if (vehicle === '__other') vehicle = get('vehicle_other');
    return {
      vehicle: vehicle,
      pcd: get('pcd'),
      diameter: get('diameter'),
      width: get('width'),
      offset: get('offset'),
      bore: get('bore'),
      qty: get('qty') || String(wheelsCfg.defaultQty || 4),
      notes: get('notes'),
      saved_at: new Date().toISOString()
    };
  }

  function fillForm(form, spec) {
    if (!form || !spec) return;
    var set = function (name, value) { var el = form.querySelector('[name="' + name + '"]'); if (el && value != null && value !== '') el.value = value; };
    var preset = form.querySelector('[data-wmg-vehicle-preset]');
    if (preset && spec.vehicle) {
      var found = false;
      Array.prototype.forEach.call(preset.options, function (o) { if (o.value === spec.vehicle) { preset.value = o.value; found = true; } });
      if (!found) { preset.value = '__other'; set('vehicle_other', spec.vehicle); }
      toggleOther(form);
    }
    set('pcd', spec.pcd); set('diameter', spec.diameter); set('width', spec.width); set('offset', spec.offset);
    set('bore', spec.bore); set('qty', spec.qty); set('notes', spec.notes);
  }

  function toggleOther(form) {
    var preset = form.querySelector('[data-wmg-vehicle-preset]');
    var other = form.querySelector('[data-wmg-vehicle-other]');
    if (!preset || !other) return;
    other.hidden = preset.value !== '__other';
  }

  function summary(spec) {
    if (!spec) return [];
    var out = [];
    if (spec.vehicle) out.push(spec.vehicle);
    if (spec.pcd) out.push(spec.pcd);
    if (spec.diameter) out.push(spec.diameter + '"' + (spec.width ? ' x ' + spec.width + 'J' : ''));
    if (spec.offset) out.push('ET ' + spec.offset);
    if (spec.bore) out.push('CB ' + spec.bore);
    if (spec.qty) out.push('x' + spec.qty);
    return out;
  }

  /* ---------- matching ---------- */
  function matches(card, spec) {
    if (!spec) return true;
    var pcds = list(card.getAttribute('data-pcd'));
    var dias = list(card.getAttribute('data-dia'));
    if (pcds.length && spec.pcd && pcds.indexOf(norm(spec.pcd)) === -1) return false;
    if (dias.length && spec.diameter) {
      var want = num(spec.diameter);
      var ok = dias.some(function (d) { return num(d) === want; });
      if (!ok) return false;
    }
    return true;
  }

  function filter() {
    if (!grid) return;
    var spec = store.get();
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-wmg-card]'));
    var shown = 0;
    cards.forEach(function (card) {
      var m = matches(card, spec);
      card.classList.toggle('is-match', !!spec && m);
      var visible = viewAll || m;
      card.hidden = !visible;
      if (visible) shown++;
    });
    if (countEl) countEl.textContent = String(shown);
    if (noMatch) noMatch.hidden = !(cards.length > 0 && shown === 0);
    if (viewAllNote) viewAllNote.hidden = !(viewAll && !spec);
    if (statusBar) {
      var lines = summary(spec);
      statusBar.hidden = lines.length === 0;
      if (chips) chips.innerHTML = lines.map(function (l) { return '<span>' + WMG.esc(l) + '</span>'; }).join('');
    }
    if (WMG.media && WMG.media.refresh) WMG.media.refresh(grid);
  }

  function unlock() { root.classList.remove('wmg-wheels-locked'); }

  function applySpec(spec) {
    store.set(spec);
    unlock();
    filter();
    document.querySelectorAll('[data-wmg-spec-form]').forEach(function (f) { fillForm(f, spec); });
  }

  /* ---------- modal ---------- */
  function openModal() {
    if (!modal) return false;
    fillForm(modal.querySelector('[data-wmg-spec-form]'), store.get());
    if (typeof modal.showModal === 'function') { if (!modal.open) modal.showModal(); }
    else { modal.classList.add('wmg-modal--fallback'); modal.setAttribute('open', ''); }
    return true;
  }
  function closeModal() {
    if (!modal) return;
    if (typeof modal.close === 'function' && modal.open) modal.close();
    modal.classList.remove('wmg-modal--fallback');
    modal.removeAttribute('open');
  }
  if (modal) {
    modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
    var closeBtn = modal.querySelector('[data-wmg-modal-close]');
    if (closeBtn) closeBtn.addEventListener('click', closeModal);
  }

  /* ---------- wheel selection ---------- */
  function selectWheel(handle) {
    if (!handle) return;
    if (!WMG.order || !WMG.order.open) {
      var url = wheelsCfg.pageUrl || (cfg.pages && cfg.pages.wheels) || '/pages/wheels';
      window.location.href = url + (url.indexOf('?') === -1 ? '?' : '&') + 'wheel=' + encodeURIComponent(handle);
      return;
    }
    fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('Product not found'); return r.json(); })
      .then(function (product) { WMG.order.open(product, store.get()); })
      .catch(function () { window.location.href = '/products/' + encodeURIComponent(handle); });
  }

  function requestSelect(handle) {
    if (requireSpec && !store.get()) {
      pendingHandle = handle;
      if (!openModal()) { unlock(); }
      return;
    }
    selectWheel(handle);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-wheel-select]') : null;
    if (btn) { e.preventDefault(); requestSelect(btn.getAttribute('data-wheel-select')); }
  });

  /* ---------- spec forms (gate + modal) ---------- */
  document.querySelectorAll('[data-wmg-spec-form]').forEach(function (form) {
    var preset = form.querySelector('[data-wmg-vehicle-preset]');
    if (preset) {
      preset.addEventListener('change', function () {
        var opt = preset.options[preset.selectedIndex];
        var pcd = form.querySelector('[name="pcd"]');
        var bore = form.querySelector('[name="bore"]');
        if (opt && opt.getAttribute('data-pcd') && pcd) {
          var v = opt.getAttribute('data-pcd');
          var has = Array.prototype.some.call(pcd.options, function (o) { return o.value === v; });
          if (!has) { var o = document.createElement('option'); o.value = v; o.textContent = v; pcd.appendChild(o); }
          pcd.value = v;
        }
        if (opt && opt.getAttribute('data-bore') && bore) bore.value = opt.getAttribute('data-bore');
        toggleOther(form);
      });
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var spec = readForm(form);
      var err = form.querySelector('[data-wmg-spec-error]');
      if (!spec.pcd || !spec.diameter) { if (err) err.hidden = false; return; }
      if (err) err.hidden = true;
      viewAll = false;
      applySpec(spec);
      closeModal();
      if (pendingHandle) { var h = pendingHandle; pendingHandle = null; selectWheel(h); }
      else if (grid) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  document.querySelectorAll('[data-wmg-view-all]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      viewAll = true;
      unlock();
      filter();
      if (grid) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
  document.querySelectorAll('[data-wmg-change-spec]').forEach(function (btn) {
    btn.addEventListener('click', function () { if (!openModal()) { store.clear(); root.classList.add('wmg-wheels-locked'); window.scrollTo(0, 0); } });
  });

  /* ---------- init ---------- */
  var spec = store.get();
  if (root.classList.contains('wmg-order-posted')) {
    store.clear();
    spec = null;
  } else if (spec) {
    unlock();
  } else if (gate) {
    root.classList.add('wmg-wheels-locked');
  }
  document.querySelectorAll('[data-wmg-spec-form]').forEach(function (f) { fillForm(f, spec); toggleOther(f); });
  filter();

  var params = new URLSearchParams(window.location.search);
  var deepLink = params.get('wheel');
  if (deepLink && grid && !root.classList.contains('wmg-order-posted')) {
    requestSelect(deepLink);
  }

  WMG.wheels = { filter: filter, openModal: openModal, select: requestSelect };
})();
